import ActiveIndicator from "@app/components/active-indicator.tsx";
import DeleteButton from "@app/components/delete-button.tsx";
import { StaffingDetailsModel } from "@app/data/engine.ts";
import { formatUsd } from "@app/helpers/money-helper.ts";
import { commaSeperate } from "@app/helpers/number-helper.ts";
import { formatDate } from "@app/helpers/time-helper.ts";
import EditIcon from "@mui/icons-material/Edit";
import { Box } from "@mui/material";
import { createColumnHelper, IconButton } from "bi-lib";

interface Props {
    onEdit: (item: StaffingDetailsModel) => void;
    onDelete: (id: number) => void;
    rowCount: number;
}

const columnHelper = createColumnHelper<StaffingDetailsModel>();
export const staffingRatesTableDefinition = ({ onEdit, onDelete, rowCount }: Props) => [
    columnHelper.display({
        id: "actions",
        header: "Actions",
        cell: (item) => (
            <Box display={"flex"}>
                <IconButton tooltip={"Edit"} onClick={() => onEdit(item.row.original)}>
                    <EditIcon />
                </IconButton>
                <DeleteButton onDelete={() => onDelete(item.row.original.staffDetailId!)} />
            </Box>
        ),
        footer: () => `${rowCount} Rows`,
    }),
    columnHelper.accessor((x) => x.effectiveDate, {
        id: "effectiveDate",
        header: "Effective Date",
        cell: (item) => formatDate(item.getValue()),
    }),
    columnHelper.group({
        id: "rate",
        header: "Rate",
        columns: [
            columnHelper.accessor((x) => x.costRate, {
                id: "costRate",
                header: "Cost",
                cell: (item) => formatUsd(item.getValue()),
                alignment: "right",
            }),
            columnHelper.accessor((x) => x.billingRate, {
                id: "billingRate",
                header: "Billing",
                cell: (item) => formatUsd(item.getValue()),
                alignment: "right",
            }),
            columnHelper.accessor((x) => x.internalRate, {
                id: "internalRate",
                header: "Internal",
                cell: (item) => formatUsd(item.getValue()),
                alignment: "right",
            }),
        ],
    }),
    columnHelper.group({
        id: "billable",
        header: "Billable",
        columns: [
            columnHelper.accessor((x) => x.billableTime, {
                id: "billableTime",
                header: "Time",
                cell: (item) => <ActiveIndicator isActive={item.getValue()} />,
            }),
            columnHelper.accessor((x) => x.billableTravelExpense, {
                id: "billableTravelExpense",
                header: "Travel Expenses",
                cell: (item) => <ActiveIndicator isActive={item.getValue()} />,
            }),
            columnHelper.accessor((x) => x.billableOtherIndividualExpense, {
                id: "billableOtherIndividualExpense",
                header: "Other Expenses",
                cell: (item) => <ActiveIndicator isActive={item.getValue()} />,
            }),
            columnHelper.accessor((x) => x.billableOfficeExpense, {
                id: "billableOfficeExpense",
                header: "Office Expenses",
                cell: (item) => <ActiveIndicator isActive={item.getValue()} />,
            }),
        ],
    }),
    columnHelper.group({
        id: "visible",
        header: "Visible",
        columns: [
            columnHelper.accessor((x) => x.invoiceVisibleTime, {
                id: "invoiceVisibleTime",
                header: "Time",
                cell: (item) => <ActiveIndicator isActive={item.getValue()} />,
            }),
            columnHelper.accessor((x) => x.invoiceVisibleTravelExpense, {
                id: "invoiceVisibleTravelExpense",
                header: "Travel Expenses",
                cell: (item) => <ActiveIndicator isActive={item.getValue()} />,
            }),
            columnHelper.accessor((x) => x.invoiceVisibleOtherIndividualExpense, {
                id: "invoiceVisibleOtherIndividualExpense",
                header: "Other Expenses",
                cell: (item) => <ActiveIndicator isActive={item.getValue()} />,
            }),
            columnHelper.accessor((x) => x.invoiceVisibleOfficeExpense, {
                id: "invoiceVisibleOfficeExpense",
                header: "Office Expenses",
                cell: (item) => <ActiveIndicator isActive={item.getValue()} />,
            }),
        ],
    }),
    columnHelper.accessor((x) => x.averageHoursPerDay, {
        id: "averageHoursPerDay",
        header: "Average Hours/Day",
        cell: (item) => commaSeperate(item.getValue()),
        alignment: "right",
    }),
];
